import { getAnalytics, logEvent } from "firebase/analytics";
import initialize from "../initialize";

export default function logAnalyticsEvent(eventName, eventParams) {
  const analytics = getAnalytics(initialize());
  // eslint-disable-next-line no-console
  console.log("logAnalyticsEvent", eventName, eventParams);
  return logEvent(analytics, eventName, eventParams);
}
